// TotalTON frontend configuration — Vite env vars (VITE_*)

export const API_URL = import.meta.env.VITE_API_URL || '';
export const CONTRACT_ADDRESS = import.meta.env.VITE_CONTRACT_ADDRESS || '';
export const TONCONNECT_MANIFEST_URL =
  import.meta.env.VITE_TONCONNECT_MANIFEST_URL ||
  `${window.location.origin}/tonconnect-manifest.json`;
export const NETWORK = import.meta.env.VITE_NETWORK || 'testnet';

// Game rules (must match the contract)
export const DEPOSIT_AMOUNT = 1_000_000_000; // 1 GRAM in nanotons
export const ROUND_DURATION = 1800;
export const PAUSE_DURATION = 300;
export const LOCK_DURATION = 1800;
export const BOT_LINK = import.meta.env.VITE_BOT_LINK || '';   // e.g. https://t.me/totalton_bot/app
export const WINNER_FEE = 75;
export const DEV_FEE = 15;
export const NEXT_ROUND_FEE = 10;

// Pre-launch: unix timestamp of the public start; 0/unset = already live
export const LAUNCH_AT = Number(import.meta.env.VITE_LAUNCH_AT || 0);

export const POLL_INTERVAL = 15_000;

// Real-time state push; falls back to polling when unavailable.
export const WS_URL: string = API_URL
  ? API_URL.replace(/^http/, 'ws') + '/ws'
  : `${window.location.protocol === 'https:' ? 'wss' : 'ws'}://${window.location.host}/ws`;

export const API_ENDPOINTS = {
  ROUND: `${API_URL}/api/round`,
  HISTORY: `${API_URL}/api/history`,
  DEPOSITS: `${API_URL}/api/deposits`,
  LOCK: `${API_URL}/api/lock`,
  LEADERBOARD: `${API_URL}/api/leaderboard`,
  STATS: `${API_URL}/api/stats`,
  WIDGET: `${API_URL}/widget.png`,
  HEALTH: `${API_URL}/health`,
} as const;

export const CURRENCY = 'GRAM';
